import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=1b157389&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=1b157389&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b157389",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/l-setting-for-configuration-tool/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b157389')) {
      api.createRecord('1b157389', component.options)
    } else {
      api.reload('1b157389', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=1b157389&scoped=true&", function () {
      api.rerender('1b157389', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/auth/components/ForgotPassword.vue"
export default component.exports